export function AuthLayout({ children }: { children: React.ReactNode }) {
	return (
		<div className="container flex min-h-full flex-col justify-center pt-12 pb-16 sm:pt-20 sm:pb-32">
			<div className="mx-auto max-w-sm min-w-full sm:min-w-[368px]">
				{children}
			</div>
		</div>
	)
}
